module.exports = __webpack_public_path__ + "img/xk.ba8a3499.svg";